import axios from "axios";
import { authRepository } from "./authRepository";

const axiosInstance = axios.create({
  baseURL: process.env.DEMO_REACT_APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem("jwt");
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

axiosInstance.interceptors.response.use(

  res => res,
  async err => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      const newToken = await authRepository.RefreshToken();
      if (newToken) {
        orig.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(orig);
      }
      authRepository.logout();
      return Promise.reject(err);
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
